import React, { useEffect, useState } from 'react'
import { useAboutUsStore } from '../../store/useAboutUs'
import Loader from '../../Components/Loader'
import { useNavigate } from 'react-router'
import { useGalleryStore } from '../../store/useGalleryStore'

const GallerySection = ({ id, handleCancel, setOpen }) => {
    const { registergallerypage, selectedGallery, gallery, getGalleryById } = useGalleryStore()
    const [data, setData] = useState({
        subTitle: '',
        title: '',
        description: '',
        isFeatured: true,
        order: null,
    })
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()

    const handleChange = (e) => {
        const { name, value } = e.target
        setData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = async () => {
        setLoading(true)
        await registergallerypage(data, id)
        setLoading(false)
        setOpen(false)
    }

    const handleSectionData = async () => {
        setLoading(true);
        try {
            const res = await getGalleryById(id);
            if (res) {
                setData({
                    title: res?.title,
                    description: res?.description,
                    isFeatured: res?.isFeatured,
                    order: res?.order,
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const getTotalGalleryFunction = () => {
        let newOrder = gallery.length + 1;
        setData((prev) => ({
            ...prev,
            order: newOrder,
        }));
    };

    useEffect(() => {
        if (id) {
            handleSectionData()
        } else {
            getTotalGalleryFunction()
        }
    }, [id]);

    return (
        <div id="story-section" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
                <h3>Add New Gallery Section</h3>
            </div>
            <Loader loading={loading}>
                <div className="p-6">
                    <div className="grid grid-cols-1 gap-6">
                        <div>
                            {/* <label class="block text-sm text-neutral-700 mb-2">Section SubTitle</label>
                            <input
                                type="text"
                                name="subTitle"
                                value={data.subTitle}
                                onChange={handleChange}
                                class="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            /> */}

                            <label className="block text-sm text-neutral-700 mb-2">Section Title</label>
                            <input
                                type="text"
                                name="title"
                                value={data.title}
                                onChange={handleChange}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">Description</label>
                            <textarea
                                rows="6"
                                name="description"
                                value={data.description}
                                onChange={handleChange}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">
                                Status
                            </label>
                            <select
                                value={data.isFeatured}
                                onChange={handleChange}
                                name='isFeatured'
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            >
                                <option value='true'>Active</option>
                                <option value='false'>Inactive</option>
                            </select>
                            <label className="block text-sm text-neutral-700 mb-2 mt-3">
                                Gallery Order
                            </label>
                            <input
                                type="text"
                                value={data?.order}
                                name="order"
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                    </div>

                    <div className="flex justify-end space-x-3 mt-8">
                        <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                            onClick={() => handleCancel()}
                        >Cancel</button>
                        <button
                            className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                            onClick={() => handleSubmit()}
                        >
                            Submit
                        </button>
                    </div>
                </div >
            </Loader >
        </div >
    )
}

export default GallerySection
